/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ProfilesStorePathParams, ProfilesStoreRequest, ProfilesStoreResponse } from '../types/ProfilesStore'

/**
 * POST /:organisation/profiles
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::store
 */
export async function profilesStore(
	organisation: ProfilesStorePathParams['organisation'],
	data: ProfilesStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesStoreResponse>> {
	return axiosInstance.post(`/${organisation}/profiles`, data, config)
}
